import React, { useEffect, useState } from 'react';
import moment from 'moment';
import cx from 'classnames';
import './LocalTimeWidget.scss';

const UPDATE_DELAY = 500;

export const LocalTimeWidget = ({ className, timezone, showTimezone = false }) => {
  const [currentTime, setCurrentTime] = useState(null);

  useEffect(() => {
    if (timezone) {
      const updateCurrentTime = () => {
        setCurrentTime({
          time: moment.tz(timezone).format('LTS'),
          timezone,
        });
      };

      const timerId = setInterval(updateCurrentTime, UPDATE_DELAY);

      return () => clearInterval(timerId);
    } else {
      setCurrentTime(null);
    }
  }, [timezone]);

  if (!currentTime) return null;

  return (
    <div className={cx('local-time-widget', [className], { 'local-time-widget__has-timezone': showTimezone })}>
      <span className="local-time-widget__label">Local Time</span>
      <span className="local-time-widget__value">{currentTime.time}</span>
      
      {showTimezone ? (
        <>
          <span className="local-time-widget__bullet" />
          <span className="local-time-widget__timezone">{`UTC ${moment.tz(currentTime.timezone).format('Z')}`}</span>
        </>
      ) : null}
    </div>
  );
};
